import * as LucideIcons from 'lucide-react';
import { ComponentType } from 'react';

type BaseIconType = {
  name: string;
  color?: string;
  size?: number;
};
export default function BaseIcon({ name, color, size }: BaseIconType) {
  const IconComponent = LucideIcons[name as keyof typeof LucideIcons] as ComponentType<any>;

  if (!IconComponent) {
    return <LucideIcons.HelpCircle color="red" />; // Fallback
  }

  return <IconComponent color={color} size={size} />;
};